
import Swal from "sweetalert2";
import { translate } from '@/i18n'
import 'sweetalert2/dist/sweetalert2.min.css'

export function notificationImportPreregisterEmailsFinished(data) {
    swalFire(data)
}

async function swalFire(data) {
    const html = textPreprocess(data)
    Swal.fire({
        title: translate('Import Preregister Finished'),
        icon: isInformativeOrErrors(data),
        html: html,
        showCloseButton: true,
        showClass: {
            popup: 'animate__animated animate__slideInDown',
        },
    })
}


function textPreprocess(data) {
    const errors = getErrors(data)
    let html = ''
    if (errors.length > 0) {
        html = convertErrorsToHTML(errors)
    }
    return html
}

function isInformativeOrErrors(data) {
    const errors = data.errors
    if (errors.length > 0) return 'error'
    return 'info'
}

function getErrors(data) {
    const errors = data.errors
    return errors
}

function convertErrorsToHTML(errors) {
    let html = `<p class="swal-longmessage">${translate('The following records could not be imported into the database')}:</p><div style="max-height: 30vh;"><ul class="swal-longmessage">`;

    errors.forEach((error, index) => {
        html += `<li class="swal-longmessage">${error}</li>`;
    });

    html += '</ul></div>';

    return html;
}

